<i *ngIf="isFunctionForWeb(text)" class="fas fa-check color-green padding-left-10" aria-hidden="true"></i>
<i *ngIf="!isFunctionForWeb(text)" class="fas fa-times padding-left-10" aria-hidden="true"></i>